module.exports = "/static/assets/6be143c7cb9d23c787f7f20674a76f72.svg";